// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2w5bC","row":"ProcedureTreatmentSummary_row__1dhQ0"};